// Exact compliance disclaimer copy, per placement.
const TEXTS = {
  // Calculators page + Mood box output
  issue:
    "Educational Notice: This web-based application operates strictly as an educational wellness simulator and lifestyle tracking utility. It does not issue medical evaluations, clinical testing, or pharmaceutical diagnoses. Users are instructed to verify all metrics against standard professional documentation and consult a qualified medical practitioner or healthcare professional regarding clinical symptoms or diagnostic guidance.",
  // Programmatic SEO template
  provide:
    "Educational Notice: This web-based application operates strictly as an educational wellness simulator and lifestyle tracking utility. It does not provide medical evaluations, clinical testing, or pharmaceutical diagnoses. Users are instructed to verify all metrics against standard professional documentation and consult a qualified medical practitioner or healthcare professional regarding clinical symptoms or diagnostic guidance.",
};

export default function ComplianceFooter({ variant = "issue" }) {
  return (
    <div
      data-testid={`compliance-footer-${variant}`}
      className="mt-10 border-t border-white/5 pt-5"
    >
      <p className="text-[11px] leading-relaxed text-zinc-500">
        {TEXTS[variant] || TEXTS.issue}
      </p>
    </div>
  );
}
